import { lazy } from "react";

export const LazyLoggedOutMobileSignUpSnackbar = lazy(() =>
  import(
    /* webpackChunkName: "retailer-logged-out-mobile-signup-snackbar" */ "@faire/retailer-visitor-shared/components/LoggedOutMobileSignUpSnackbar/LoggedOutMobileSignUpSnackbar"
  ).then((m) => ({ default: m.LoggedOutMobileSignUpSnackbar }))
);
